<cs-top10-game-tile-aggregator [withOverlay]="!gameTileSettings.isTouch" [withFav]="true" [gradientIndex]="tileIndex()">
    <cs-gradient-number [gradientIndex]="tileIndex()" slot="gradient" />

    <cs-image-loader
        [disableLazyLoading]="false"
        [isDll]="true"
        [enableFallback]="false"
        [lazySrc]="topTenGame().img.lazySrc"
        [src]="topTenGame().img.src"
        [defaultSrc]="topTenGame().img.defaultSrc"
        [icon]="gameTileSettings.icon"
        [isImageLoaded]="false"
        [isLegacy]="isLegacy()"
        (click)="onGameLaunch(topTenGame().game)"
        slot="imageLoader" />

    <cs-badge
        [size]="'xsmall'"
        [variant]="'primary'"
        [isLegacy]="isLegacy()"
        [badges]="topTenGame().badges"
        [stickerStyles]="stickerStyles"
        [isUk]="true"
        slot="badge" />

    <cs-freespinssummary-icon
        [isOptedIn]="topTenGame().freespins?.isOptedIn"
        [isLegacy]="isLegacy()"
        [freespinscountbg]="topTenGame().freespins?.background"
        [freespinAvailableCount]="topTenGame().freespins?.available"
        [freespinTotalCount]="topTenGame().freespins?.total"
        csFreespinsSummary
        slot="freespinsSummaryIcon" />

    <cs-fav-cta
        [showIcon]="!isMoreInfoEnabled()"
        [variant]="'hollow'"
        [iconKind]="getFavVariantKind()"
        slot="gametileFavCta"
        [gameId]="topTenGame().gameId"
        csFavoriteConjugate
        [csFavoriteConjugateIconKind]="getFavVariantKind()"
        [shouldTrackSection]="true"
        [gameSection]="topTenGame().game.gameSection" />

    <cs-quick-info-icon
        [showIcon]="gameTileSettings.isTouch && isNewQuickInfoEnabled()"
        slot="quickInfoIcon"
        [game]="topTenGame().game"
        [categoryType]="subCategory()"
        [lobbyType]="lobbyType()"
        csMoreInfo />

    <button
        ds-button
        [id]="'play-now-' + topTenGame().game"
        [variant]="'filled'"
        [kind]="'primary'"
        [size]="'medium'"
        slot="gameTileCta"
        (click)="onGameLaunch(topTenGame().game)">
        {{ gameTileSettings.gameLaunch.ctaText }}
    </button>

    <!-- More Info -->
    <cs-hyperlink-cta
        [showIcon]="isNewQuickInfoEnabled() && newQuickInfoStyle()"
        [isLegacy]="gameTileSettings.moreInfo"
        [variant]="'flat'"
        [kind]="'primary'"
        [size]="'small'"
        [cta_text]="gameTileSettings.moreInfo.displayText"
        [casinoDsClass]="'overlay-moreinfo'"
        slot="hyperlinkCta"
        [game]="topTenGame().game"
        [categoryType]="subCategory()"
        [lobbyType]="lobbyType()"
        csMoreInfo />

    <cs-jackpot-ribbon
        [alignment]="jackpotRibbonNewStyling"
        [withIcon]="jackpotRibbonData.withIcon"
        [iconImage]="jackpotRibbonData.iconImage"
        [isLegacy]="isLegacy()"
        csWithJPIncrementalTicking
        [tickIncrement]="1"
        csWithJackpotValueEventHydrator
        [jackpotGameId]="topTenGame().gameId"
        slot="jackpotHotIcon" />

    <cs-tile-footer
        [categoryNametext]="topTenGame().footer?.firstLineText"
        [gameNametext]="topTenGame().footer?.secondLineText"
        [gameTypeText]="topTenGame().footer?.thirdLineText"
        [inlineStyleCategoryName]=""
        [inlineStyleGameName]=""
        [inlineStyleGameType]=""
        slot="gameTileFooter" />
</cs-top10-game-tile-aggregator>
